import { type DataSchemaType } from "../schema-type";
import { WorkflowParameterType } from "../workflow.types";

// ── Helper to build output format ─────────────────────────────────────────────

export const str = (desc: string): DataSchemaType => ({
  type: WorkflowParameterType.STRING,
  description: desc
});
export const num = (desc: string): DataSchemaType => ({
  type: WorkflowParameterType.NUMBER,
  description: desc
});
export const bool = (desc: string): DataSchemaType => ({
  type: WorkflowParameterType.BOOLEAN,
  description: desc
});
export const obj = (desc: string, properties?: Record<string, DataSchemaType>): DataSchemaType => ({
  type: WorkflowParameterType.OBJECT,
  description: desc,
  ...(properties ? { properties } : {})
});
export const arr = (desc: string, items?: DataSchemaType): DataSchemaType => ({
  type: WorkflowParameterType.ARRAY,
  description: desc,
  ...(items ? { items } : {})
});

// ── Generic output formats ────────────────────────────────────────────────────

export const listOutput = (itemName: string) =>
  obj("Result", {
    [itemName]: arr(`List of ${itemName}`),
    total: num("Total count")
  });

export const deleteOutput = obj("Result", {
  id: str("Deleted item ID"),
  deleted: bool("Deletion status")
});
